// Shared copy for deactivate / reinstate / delete so every screen warns the same way.
export const ACCOUNT_ACTIONS = {
  staff: {
    deactivate: {
      title: 'Deactivate user',
      confirmText: 'Deactivate',
      description: 'Block this user from logging in. Their data is kept and you can reinstate them later.',
      message: (name) => `Deactivate ${name}? They will lose access until an administrator reinstates them.`,
      effects: [
        'They are signed out immediately and cannot log in.',
        'Their role, scope and history are kept as they are.',
        'They stay in the Users list with an Inactive status.',
        'You can reinstate the account at any time.',
      ],
    },
    reinstate: {
      title: 'Reinstate user',
      confirmText: 'Reinstate',
      description: 'This user is inactive. Reinstating lets them log in again.',
      message: (name) => `Reinstate ${name}? They will be able to log in again.`,
      effects: ['They can log in with their existing password.', 'Their role and scope are unchanged.'],
    },
    remove: {
      title: 'Delete user',
      confirmText: 'Delete',
      description: 'Permanently remove this user account. This action cannot be undone.',
      message: (name) => `Delete ${name}? This cannot be undone from the portal.`,
      effects: [
        'The account is removed from the Users list and from exports.',
        'They are signed out and can never log in again.',
        'Claims, approvals and audit entries they created stay on record.',
        'To keep the option of returning, deactivate instead.',
      ],
    },
  },
};
